import { prettify, renderDeviceName, renderEUDate } from "../../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { devices } from "../../DeviceComponents";

const columns = [
  {
    size: 120,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorFn: (row) => prettify(row.name),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Dispositivo",
  },

  {
    size: 120,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorFn: (row) => renderDeviceName(row.device_type),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Tipologia",
  },
  {
    size: 120,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorKey: "serial_number",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Seriale",
  },
  {
    size: 100,
    enableColumnFilter: false,
    accessorFn: (row) => renderEUDate(row.last_connection),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Ultima connessione",
  },
  {
    size: 80,
    enableColumnFilter: false,
    accessorKey: "battery_perc", // TODO: CELLULARE SE NON C'è TELEFONO?
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Batteria",
  },
  {
    size: 5,
    accessorKey: "is_installed",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_installed ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Installato",
  },
  {
    size: 5,
    accessorKey: "is_online",
    enableColumnFilter: false, // TODO
    accessorFn: (row) => (row.is_online ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Online",
  },
];

export default columns;
